export default 'https://tme.understood.org/assets/toaster.f2068bba.glb'